import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  pendingCompanyActions,
  pendingCompanyFilterActions,
  pendingCompanyFilters,
  pendingCompanySelectors,
} from '../';
import useFilters from 'containers/Base/useFilters.js';
import LayoutWithMap from 'containers/Base/LayoutWithMap.jsx';
import PropTypes from 'prop-types';
import { getCountryList } from 'reducers/utils';
import { modalState, toggleModal } from 'reducers/ui';
import { PAGE_URLS } from 'utils/constants';

const PendingCompanies = ({
  columns,
  filtersRequired,
  details,
  loading,
  FormComponent,
  editable,
}) => {
  //---------------------------Selectors---------------------------
  const pendingCompaniesListData = useSelector(state =>
    pendingCompanySelectors.getPendingCompanyList(state),
  );
  const modalOpen = useSelector(state => modalState(state));
  const totalEntries = useSelector(state =>
    pendingCompanySelectors.getTotalEntries(state),
  );
  const filterValues = useSelector(state =>
    pendingCompanySelectors.getFilters(state),
  );
  const forceRefresh = useSelector(state =>
    pendingCompanySelectors.getForceRefresh(state),
  );
  const countryList = useSelector(state => getCountryList(state));
  //--------------------------customHooks--------------------------
  const { localFilterValues, updateFilter } = useFilters({
    filterValues,
  });
  //---------------------------Actions------------------------------
  const dispatch = useDispatch();
  const dispatchFetchPendingCompaniesList = useCallback(
    ({ filters, from }) =>
      dispatch(pendingCompanyActions.fetchGridList({ filters, from })),
    [dispatch],
  );
  const dispatchToggleModal = useCallback(
    () => dispatch(toggleModal(PAGE_URLS.PENDING_COMPANY.name)),
    [dispatch],
  );
  //---------------------------------------------------------------
  const onUpdate = filters => {
    dispatchFetchPendingCompaniesList({
      filters,
    });
  };
  const fetchPendingCompanies = from => {
    dispatchFetchPendingCompaniesList({ filters: localFilterValues, from });
  };
  const PendingCompanyFormComponent = useCallback(
    props => <FormComponent {...props} />,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );
  return (
    <LayoutWithMap
      header="Pending Companies"
      cols={columns}
      data={pendingCompaniesListData}
      totalEntries={totalEntries}
      loading={loading}
      forceRefresh={forceRefresh}
      DetailComponent={details}
      //filters
      filtersRequired={filtersRequired}
      filterValues={localFilterValues}
      filters={pendingCompanyFilters(countryList)}
      setFilters={(values, hasApplyFilter) =>
        updateFilter({
          values,
          hasApplyFilter,
          applyFilter: filters => {
            pendingCompanyFilterActions.setFilterKey({ key: true });
            pendingCompanyFilterActions.setFilters({ filters });
          },
        })
      }
      //end-filters
      editable={editable} //can only edit not create
      onEdit={modalOpen[PAGE_URLS.PENDING_COMPANY.name]}
      toggleModal={dispatchToggleModal}
      onUpdate={onUpdate}
      FormComponent={PendingCompanyFormComponent}
      fetchData={fetchPendingCompanies}
    />
  );
};
PendingCompanies.propTypes = {
  columns: PropTypes.array.isRequired,
  details: PropTypes.func.isRequired,
  filtersRequired: PropTypes.bool.isRequired,
  loading: PropTypes.bool,
  FormComponent: PropTypes.elementType,
  editable: PropTypes.bool,
};
export default PendingCompanies;
